module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "width": _vm.isMobileSize ? '90%' : '40%',
      "persistent": ""
    },
    model: {
      value: (_vm.mostrarModal),
      callback: function($$v) {
        _vm.mostrarModal = $$v
      },
      expression: "mostrarModal"
    }
  }, [_c('v-card', {
    staticClass: "popup-modal"
  }, [_c('v-container', [_c('h3', {
    staticClass: "pb-3",
    class: {
      'display-0': _vm.isMobileSize, 'display-1': !_vm.isMobileSize
    }
  }, [_vm._v("\n          Atualização\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    class: {
      'body-1': _vm.isMobileSize, 'subheading': !_vm.isMobileSize
    }
  }, [_vm._v("\n            Olá, você está com uma versão antiga desta aplicação no seu navegador. Clique em fechar\n            para atualizar. Se essa mensagem persistir, por favor, force a atualização diretamente pelo seu navegador.\n          ")])])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.fecharModal
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-17d5672f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/main/UpdateManager.vue
// module id = 527
// module chunks = 2